import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StoryViewer } from "@/components/stories/StoryViewer";

let groups = [];
let openIdx = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f());
let loading = false;

export async function reloadStoryRings() {
  if (loading) return;
  loading = true;
  try { groups = (await api.get("/stories")).data || []; emit(); } catch { /* not logged in */ } finally { loading = false; }
}

const useStore = () => {
  const [, set] = useState(0);
  useEffect(() => { const f = () => set((n) => n + 1); subs.add(f); return () => subs.delete(f); }, []);
};

export function useStoryRing(userId) {
  useStore();
  const g = userId && groups.find((x) => x.user.user_id === userId);
  return g ? { seen: g.all_seen, open: () => { openIdx = groups.indexOf(g); emit(); } } : null;
}

export function StoryRingHost() {
  useStore();
  useEffect(() => {
    reloadStoryRings();
    const t = setInterval(reloadStoryRings, 90000);
    window.addEventListener("stories-changed", reloadStoryRings);
    return () => { clearInterval(t); window.removeEventListener("stories-changed", reloadStoryRings); };
  }, []);
  if (openIdx === null || !groups[openIdx]) return null;
  const close = () => { openIdx = null; emit(); reloadStoryRings(); window.dispatchEvent(new Event("stories-changed-bar")); };
  const onSeen = (id) => {
    groups = groups.map((g) => { const stories = g.stories.map((s) => (s.id === id ? { ...s, seen: true } : s)); return { ...g, stories, all_seen: stories.every((s) => s.seen) }; });
    emit();
  };
  return <StoryViewer groups={groups} start={openIdx} onClose={close} onSeen={onSeen} onDeleted={reloadStoryRings} />;
}
